import i18n, { type Resource } from "i18next";
import { initReactI18next } from "react-i18next";

import enApp from "@/locales/en/app.json";
import koApp from "@/locales/ko/app.json";

import { normalizeLanguage as normalizeStoredLanguage } from "@/context/app-shell-storage";

export type AppLanguage = "en" | "ko";

export function normalizeLanguage(lang: unknown): AppLanguage {
  // 정규화 규칙은 app-shell-storage 가 SSOT 다. 여기서 따로 구현하면
  // 기본 언어가 갈려(en vs ko) first-paint 와 저장값이 어긋난다.
  return normalizeStoredLanguage(
    lang === null || lang === undefined ? undefined : String(lang),
  );
}

let _initialized = false;

export function initI18n(language?: unknown) {
  if (_initialized) return i18n;

  // ko is bundled up-front (it is the default); en stays as the fallback bundle.
  const resources: Resource = {
    en: { app: enApp },
    ko: { app: koApp },
  };

  i18n.use(initReactI18next).init({
    resources,
    lng: normalizeLanguage(language),
    // 지원 언어는 ko/en 2종이고 기본은 ko다.
    // 키가 없을 때 영어 원문으로 떨어지는 건 키 자체가 영어 원문이라 자연스럽다.
    fallbackLng: "en",
    // Use a single default namespace to keep lookups simple.
    // We intentionally keep keySeparator disabled so keys like "Generating..." remain valid.
    defaultNS: "app",
    ns: ["app"],
    keySeparator: false,
    interpolation: {
      escapeValue: false,
    },
    returnEmptyString: false,
    returnNull: false,
  });

  _initialized = true;
  return i18n;
}

export async function ensureLanguage(language: AppLanguage) {
  if (i18n.hasResourceBundle(language, "app")) return;
  if (language === "ko") {
    const koAppBundle = (await import("@/locales/ko/app.json")).default;
    i18n.addResourceBundle("ko", "app", koAppBundle, true, true);
  }
}
